/**
 * Hero background videos: muted inline autoplay with aggressive play() retries (iOS often defers autoplay).
 * Does not add any play button; CTA links in the section are unrelated markup.
 */
(function () {
  if (!window.__vhbListenersBound) {
    window.__vhbListenersBound = true;
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('cc-video-hero-banner')) {
        scan(e.target);
      }
    });
  }

  function tryPlay(video) {
    if (!video || video.tagName !== 'VIDEO') return;
    video.muted = true;
    video.defaultMuted = true;
    var p = video.play();
    if (p && typeof p.catch === 'function') {
      p.catch(function () {});
    }
  }

  function initVideo(video) {
    if (video.dataset.vhbInit) return;
    video.dataset.vhbInit = '1';

    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    if (video.controls) {
      video.controls = false;
    }

    var pauseRetries = 0;
    var maxPauseRetries = 25;

    function run() {
      tryPlay(video);
    }

    function scheduleBurst() {
      var delays = [0, 30, 60, 120, 250, 500, 800, 1300, 2000, 3500];
      var done = false;
      function stop() {
        done = true;
      }
      video.addEventListener('playing', stop, { once: true });
      delays.forEach(function (ms) {
        setTimeout(function () {
          if (!done) run();
        }, ms);
      });
      var frames = 0;
      function rafLoop() {
        if (done || frames++ > 200) return;
        if (!video.paused && video.readyState >= 2) {
          stop();
          return;
        }
        run();
        requestAnimationFrame(rafLoop);
      }
      requestAnimationFrame(rafLoop);
    }

    scheduleBurst();
    video.addEventListener('loadeddata', run);
    video.addEventListener('canplay', run);
    video.addEventListener('canplaythrough', run, { once: true });

    function revealHeroVideo() {
      var media = video.closest('.video-hero-banner__media');
      if (media) media.classList.add('vhb-video-playing');
    }

    video.addEventListener('playing', function () {
      pauseRetries = 0;
      revealHeroVideo();
    });

    video.addEventListener(
      'timeupdate',
      function onFirstFrame() {
        if (video.currentTime > 0.02) {
          revealHeroVideo();
          video.removeEventListener('timeupdate', onFirstFrame);
        }
      },
      false
    );

    var pauseTimer;
    video.addEventListener(
      'pause',
      function () {
        if (video.ended) return;
        clearTimeout(pauseTimer);
        pauseTimer = setTimeout(function () {
          if (!video.paused || video.ended) return;
          if (pauseRetries >= maxPauseRetries) return;
          pauseRetries += 1;
          run();
        }, 120);
      },
      false
    );

    ['stalled', 'waiting', 'suspend'].forEach(function (evt) {
      video.addEventListener(evt, run);
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              run();
              setTimeout(run, 200);
            }
          });
        },
        { rootMargin: '80px', threshold: 0 }
      );
      io.observe(video);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') {
        run();
        setTimeout(run, 200);
        setTimeout(run, 600);
      }
    });
  }

  function scan(root) {
    var container = root && root.querySelectorAll ? root : document;
    container.querySelectorAll('video.video-hero-banner__video').forEach(initVideo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }
})();
